import styled from 'styled-components'
import { COLORS } from 'app/constants/STYLES'
import { DropdownContent } from './HeaderDropdown/styles'

export const HeaderContainer = styled.div<{ background: string }>`
	position: sticky;
	top: 0;
	background-color: ${props => props.background};
	backdrop-filter: blur(10px);
	z-index: 1000;
	font-size: 1.3rem;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	width: 100%;
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
`

export const HeaderButtonWrap = styled.div<{ display: string }>`
	display: ${props => props.display};
	display: flex !important;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	max-width: 1350px;
	gap: 20px;

	@media (max-width: 1350px) {
		padding: 0 20px;
	}

	@media (max-width: 1200px) {
		gap: 12px;
	}

	@media (max-width: 768px) {
		gap: 8px;
	}
`

export const MobileMenuButton = styled.button`
	display: none;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	border-radius: 6px;
	border: none;
	background: transparent;
	color: ${props => props.theme.COLORS.textw};
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		background: ${props => props.theme.COLORS.point + '20'};
		color: ${props => props.theme.COLORS.point};
	}

	@media (max-width: 768px) {
		display: flex;
	}
`

export const MobileMenuOverlay = styled.div<{ isOpen: boolean }>`
	display: none;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 9998;
	opacity: ${props => props.isOpen ? 1 : 0};
	pointer-events: ${props => props.isOpen ? 'auto' : 'none'};
	transition: opacity 0.3s ease;

	@media (max-width: 768px) {
		display: block;
	}
`

export const MobileMenuDrawer = styled.div<{ isOpen: boolean }>`
	display: none;
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	width: 280px;
	background: ${props => props.theme.COLORS.bgColor};
	box-shadow: 2px 0 12px rgba(0, 0, 0, 0.1);
	z-index: 9999;
	transform: translateX(${props => props.isOpen ? '0' : '-100%'});
	transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	overflow-y: auto;

	@media (max-width: 768px) {
		display: flex;
		flex-direction: column;
	}
`

export const MobileMenuHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px 20px;
	border-bottom: 1px solid ${props => props.theme.COLORS.stroke};
`

export const MobileMenuContent = styled.div`
	display: flex;
	flex-direction: column;
	padding: 12px 0;
	gap: 4px;
	flex: 1;
	overflow-y: auto;
`

export const MobileMenuFooter = styled.div`
	display: flex;
	flex-direction: column;
	padding: 12px 20px;
	gap: 12px;
	border-top: 1px solid ${props => props.theme.COLORS.stroke};
	background: ${props => props.theme.COLORS.bgColor};
`

export const MobileMenuSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 8px 0;
	border-bottom: 1px solid ${props => props.theme.COLORS.stroke};
`

export const MobileMenuSectionTitle = styled.div`
	font-size: 11px;
	font-weight: 600;
	color: ${props => props.theme.COLORS.subText};
	padding: 8px 20px 4px;
	text-transform: uppercase;
	letter-spacing: 0.5px;
`

export const MobileMenuItem = styled.div`
	display: flex;
	align-items: center;
	padding: 12px 20px;
	color: ${props => props.theme.COLORS.textw};
	cursor: pointer;
	transition: all 0.2s ease;
	font-size: 14px;
	font-weight: 500;

	&:hover {
		background: ${props => props.theme.COLORS.point + '15'};
		color: ${props => props.theme.COLORS.point};
	}

	&:active {
		background: ${props => props.theme.COLORS.point + '25'};
	}
`

export const DesktopMenu = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 4px;
	flex-wrap: nowrap;

	@media (max-width: 768px) {
		display: none;
	}
`

// Global CSS for desktop-only elements
export const GlobalDesktopOnly = `
	@media (max-width: 768px) {
		.desktop-only {
			display: none !important;
		}
	}
`

export const NavBarToggle = styled.span`
	display: none;
`

export const HeaderButtonSection = styled.div<{
	width
	background
	hover?: boolean
}>`
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	padding: 6px 10px;
	height: 32px;
	border-radius: 6px;
	color: ${props => props.theme.COLORS.textw};
	transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
	position: relative;
	white-space: nowrap;

	&:hover {
		color: ${props => props.theme.COLORS.white};
		background-color: ${props => props.theme.COLORS.point};
		transform: translateY(-1px);
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	}

	&:active {
		transform: translateY(0);
	}

	${({ hover }) =>
		hover &&
		`&:hover ${DropdownContent} {
		display: block;
	}`}

	@media (max-width: 1200px) {
		padding: 5px 8px;
		height: 28px;
	}

	@media (max-width: 900px) {
		padding: 4px 6px;
		height: 26px;
	}
`

export const HeaderButtonText = styled.div`
	margin-left: 0.3rem;
	padding-right: 0.2rem;
	font-weight: 500;
	font-size: 12px;
	letter-spacing: -0.2px;
	white-space: nowrap;

	@media (max-width: 1200px) {
		font-size: 11px;
	}

	@media (max-width: 900px) {
		font-size: 10.5px;
		margin-left: 0.2rem;
	}
`

export const MobileView = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 90%;
	padding-right: 20px;
	@media (min-width: 900px) {
		display: none;
	}
`
